// src/components/Layout.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart } from 'react-icons/fa';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <Link to="/" className="flex items-center space-x-3 space-x-reverse">
              <img 
                src="/happiness-logo.png" 
                alt="مؤشر السعادة" 
                className="h-14 w-auto"
              />
            </Link>
            <div className="flex items-center space-x-4 space-x-reverse">
              <span className="text-sm text-gray-600 hidden sm:block">
                تطوير
              </span>
              <a 
                href="https://muathirun.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img 
                  src="/muathirun-logo.png" 
                  alt="مؤثرون" 
                  className="h-10 w-auto"
                />
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <div className="flex items-center space-x-4 space-x-reverse">
              <img 
                src="/happiness-logo.png" 
                alt="مؤشر السعادة" 
                className="h-8 w-auto opacity-60"
              />
              <div className="text-center sm:text-right">
                <p className="text-gray-600 text-sm">
                  أداة لقياس السعادة في بيئة العمل
                </p>
                <p className="text-gray-500 text-xs mt-1">
                  مبنية على الأبحاث العلمية في السعادة الوظيفية
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-4 space-x-reverse">
              <span className="text-gray-500 text-sm flex items-center">
                تطوير <FaHeart className="mx-1 text-red-500" />
                <a 
                  href="https://muathirun.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary-green transition-colors"
                >
                  مؤثرون
                </a>
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
